<template>
  <TransitionGroup
    tag="div"
    name="notification-slide"
    class="app-notifications"
    role="region"
    aria-label="Notifications"
    aria-live="polite"
  >
    <div
      v-for="notification in notifications"
      :key="notification.id"
      :class="alertClass(notification)"
      role="status"
    >
      <i :class="iconClass(notification)" aria-hidden="true"></i>
      <h2>{{ notification.title }}</h2>
      <section v-if="notification.description">{{ notification.description }}</section>
      <button
        class="btn-icon-outline notification-close"
        type="button"
        aria-label="Dismiss notification"
        @click="dismiss(notification.id)"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
  </TransitionGroup>
</template>

<script>
export default {
  name: 'AppNotifications',
  computed: {
    notifications() {
      return this.$store.getters['getNotifications']
    },
  },
  methods: {
    notificationType(notification) {
      return ['success', 'warning', 'danger'].includes(notification.type) ? notification.type : 'warning'
    },
    alertClass(notification) {
      const type = this.notificationType(notification)

      return [
        type === 'danger' ? 'alert-destructive' : 'alert',
        'app-notification',
        `app-notification-${type}`,
      ]
    },
    iconClass(notification) {
      const icons = {
        danger: 'fa-solid fa-circle-exclamation',
        success: 'fa-solid fa-circle-check',
        warning: 'fa-solid fa-triangle-exclamation',
      }

      return icons[this.notificationType(notification)]
    },
    dismiss(id) {
      this.$store.dispatch('dismissNotification', id)
    },
  },
}
</script>
